export const getDaysDifference = (day1: number, day2: number) => {
  const difference = day1 - day2;
  return Math.floor(difference / (1000 * 3600 * 24));
};

export const getDaysDifferenceFromNow = (date: string) => {
  const day = Date.parse(date);
  const now = new Date().getTime();
  return getDaysDifference(day, now);
};

export const getDaysDifferenceToNow = (date: string) => {
  const day = Date.parse(date);
  const now = new Date().getTime();
  return getDaysDifference(now, day);
};

